import { Sparkles } from "lucide-react";
import { Link } from "react-router-dom";

import { Button } from "@/components/ui";
import { ROUTES } from "@/constants/routes";
import { useAuthStore } from "@/store/auth.store";

const FinalCta = () => {
  const { isAuthenticated } = useAuthStore();

  return (
    <section className="mx-auto mt-20 max-w-2xl px-4 sm:px-6">
      <div className="relative overflow-hidden rounded-3xl bg-linear-to-br from-brown-700 via-brown-600 to-brown-500 p-10 text-center text-white sm:p-14">
        <div
          aria-hidden="true"
          className="pointer-events-none absolute -top-2/5 -right-10 h-72 w-72 rounded-full bg-white/5"
        />
        <h2 className="relative font-extrabold text-2xl tracking-tight sm:text-4xl">
          Start posting. Stop overthinking.
        </h2>
        <p className="relative mt-3 mb-8 text-[15px] text-white/70">
          Join thousands of creators who never touch a camera.
        </p>
        <Button
          variant="outline"
          asChild
          size="lg"
          className="h-13 px-8 font-bold text-base sm:text-lg"
        >
          <Link to={isAuthenticated ? ROUTES.CREATE : ROUTES.SIGNUP}>
            <Sparkles />
            Create Your AI Twin
          </Link>
        </Button>
      </div>
    </section>
  );
};

export default FinalCta;
